import { findSkuDetail } from "../../utils/findSkuDetail";
import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect, useRef } from "react";
import Axios from "axios";
import Barcode from "react-barcode";
import "./hashing.css";
import { useReactToPrint } from "react-to-print";
import Table from "react-bootstrap/Table";

const Hashing = () => {
  const [data2, setData] = useState([]);
  const [details, setDetails] = useState([]);
  const [barcodeRange, setBarcodeRange] = useState({ start: 1, end: 10 });
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [barcodeData, setBarcodeData] = useState([]);
  const [isRangeApplied, setIsRangeApplied] = useState(false);
  const [loadingUnmatched, setLoadingUnmatched] = useState(false);
  const [unmatchedBatchId, setUnmatchedBatchId] = useState("");
  const [unmatchedBarcodeData, setUnmatchedBarcodeData] = useState([]);
  const [showUnmatched, setShowUnmatched] = useState(false);
  const [unmatchedCount, setUnmatchedCount] = useState(0);

  const applyBarcodeRange = () => {
    setIsRangeApplied(true);
  };
  const fetchUnmatchedBarcodes = async () => {
    if (!unmatchedBatchId) {
      alert("Please enter BatchId");
      return;
    }

    try {
      setLoadingUnmatched(true);
      setUnmatchedBarcodeData([]);

      const res = await Axios.get(
        `${INVENTORY_API_BASE_URL}/api/randomcode/unmatched-keys/${unmatchedBatchId}`
      );

      const { barcodeData, unmatchedCount } = res.data;

      const formattedData = barcodeData.map((item) => ({
        key: item.key,
        value: item.value,
        detail: findSkuDetail(details, item.key),
      }));

      setUnmatchedBarcodeData(formattedData);
      setUnmatchedCount(unmatchedCount);
    } catch (err) {
      alert("Error fetching Destroy barcodes");
      console.error(err);
    } finally {
      setLoadingUnmatched(false);
    }
  };

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/latestRandomCode`).then(
      (response) => {
        setData(response.data);
      }
    );

    Axios.get(`${INVENTORY_API_BASE_URL}/getlist`).then((response) => {
      const filteredData = response.data.map((item) => ({
        sku: item.sku,
        title: item.title,
        Medium: item.Medium,
        edition: item.edition,
      }));
      setDetails(filteredData);
    });
  }, []);

  useEffect(() => {
    if (selectedBatch && isRangeApplied) {
      const batchData = data2.find((batch) => batch.batchId === selectedBatch);
      if (batchData) {
        const filteredBarcodeData = batchData.keyValuePairs
          .slice(barcodeRange.start - 1, barcodeRange.end)
          .map(({ key, value }) => ({
            key,
            value,
            detail: findSkuDetail(details, key),
          }));
        setBarcodeData(filteredBarcodeData);
      }
      setIsRangeApplied(false);
    }
  }, [selectedBatch, data2, details, barcodeRange, isRangeApplied]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "barcode",
  });

  const handleBatchClick = (batchId) => {
    setSelectedBatch(batchId);
  };

  const handleRangeChange = (field, value) => {
    setBarcodeRange((prevRange) => ({
      ...prevRange,
      [field]: value,
    }));
  };
  const selectedBatchData = data2.find(
    (batch) => batch.batchId === selectedBatch
  );
  const keyValuePairsLength = selectedBatchData?.keyValuePairs?.length || 0;

  return (
    <div className="hash-container">
      <div style={{ marginLeft: "20rem", marginTop: "5rem" }}>
        <h4 className="PrintRan">Print Random Barcodes</h4>
        <div style={{ width: "15rem" }}>
          <select
            style={{ height: "3rem" }}
            onChange={(e) => handleBatchClick(e.target.value)}
          >
            <option value="">Select SKU</option>
            {data2.map((batch) => (
              <option key={batch.batchId} value={batch.batchId}>
                {batch.batchId}
              </option>
            ))}
          </select>
        </div>

        {selectedBatch && (
          <div style={{ marginLeft: "1rem" }}>
            <h5 style={{ marginTop: "1rem", marginBottom: "1rem" }}>
              Key Value Pairs for Batch: <b>{selectedBatch}</b> (Total:{" "}
              <b>{keyValuePairsLength}</b>)
            </h5>
            <Table style={{ width: "50rem" }}>
              <thead id="swed">
                <tr>
                  <th>Serial Number</th>
                  <th>Random Code</th>
                  <th>Title</th>
                  <th>Medium</th>
                  <th>Edition</th>
                </tr>
              </thead>
              <tbody>
                {barcodeData.map(({ key, value, detail }) => (
                  <tr key={key}>
                    <td>{key}</td>
                    <td>{value}</td>
                    {detail && (
                      <>
                        <td>{detail.title}</td>
                        <td>{detail.Medium}</td>
                        <td>{detail.edition}</td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
        <input
          style={{ width: "15rem" }}
          type="number"
          placeholder="Start"
          value={barcodeRange.start}
          onChange={(e) => handleRangeChange("start", parseInt(e.target.value))}
        />
        <input
          style={{ width: "15rem" }}
          type="number"
          placeholder="End"
          value={barcodeRange.end}
          onChange={(e) => handleRangeChange("end", parseInt(e.target.value))}
        />
        <button onClick={applyBarcodeRange}>Apply Range</button>

        <label
          style={{
            display: "inline-flex",
            alignItems: "center",
            fontWeight: "bold",
            marginLeft: "5rem",
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          <input
            type="radio"
            name="barcodeType"
            checked={showUnmatched}
            onChange={() => setShowUnmatched(true)}
            style={{ marginRight: "6px" }}
          />
          Print Destroy Barcodes
        </label>

        {showUnmatched && (
          <div style={{ marginTop: "2rem" }}>
            <h5>Print Destroy Barcodes</h5>

            <input
              style={{ width: "15rem" }}
              type="text"
              placeholder="Enter BatchId"
              value={unmatchedBatchId}
              onChange={(e) => setUnmatchedBatchId(e.target.value)}
            />

            <button
              onClick={fetchUnmatchedBarcodes}
              style={{ marginLeft: "1rem" }}
              disabled={loadingUnmatched}
            >
              {loadingUnmatched ? "Loading..." : "Get Destroy Barcodes"}
            </button>
          </div>
        )}
        {unmatchedCount > 0 && (
          <p
            style={{ marginTop: "0.5rem", fontWeight: "bold", color: "green" }}
          >
            Total Destroy Barcodes : {unmatchedCount}
          </p>
        )}

        {selectedBatch && (
          <div ref={componentRef}>
            <div className="serialbarcode">
              {barcodeData.map(({ key, value, detail }) => (
                <div className="codeContainer" key={key}>
                  {detail && (
                    <>
                      <p className="barcodetitle">
                        {detail.title.substring(0, 30)}
                      </p>
                      <p className="barcodeMedium">
                        {detail.Medium} {detail.edition}
                      </p>
                    </>
                  )}
                  <div style={{ fontFamily: "Roboto" }}>
                    <Barcode
                      height="24rem"
                      width="1rem"
                      fontSize="10rem"
                      marginLeft="1rem"
                      value={value}
                      marginTop="4rem"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {unmatchedBarcodeData.length > 0 && (
          <div ref={componentRef}>
            <div className="serialbarcode">
              {unmatchedBarcodeData.map(({ key, value, detail }) => (
                <div className="codeContainer" key={key}>
                  {detail && (
                    <>
                      <p className="barcodetitle">
                        {detail.title.substring(0, 30)}
                      </p>
                      <p className="barcodeMedium">
                        {detail.Medium} {detail.edition}
                      </p>
                    </>
                  )}
                  <Barcode
                    height="24rem"
                    width="1rem"
                    fontSize="10rem"
                    marginLeft="1rem"
                    value={value}
                    marginTop="4rem"
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {(selectedBatch || unmatchedBarcodeData.length > 0) && (
          <button className="printbtn" onClick={handlePrint}>
            Print Barcode
          </button>
        )}
      </div>
    </div>
  );
};

export default Hashing;
